import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { api } from "../../../../../../../utility/AxiosInceptor";

import UpdateBillingModel from "./components/update_billing_model";
import { ToastContainer } from "react-toastify";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { toast } from "react-toastify";
import AddBillingModel from "./components/add_billing_model";

const loginRes = localStorage.getItem("userData");
const parseLoginRes = JSON.parse(loginRes);
export default function ListAllBilling() {
  const [refresh, setRefresh] = useState(false);
  const [editBillingModelVisibility, setEditBillingModelVisibility] =
    useState(false);
  useEffect(() => {
    if (editBillingModelVisibility === false) {
      api
        .get(`/api/billingModal/all?serviceProvider=${parseLoginRes?.company}`)
        .then((res) => {
          setBillingModelList(res?.data?.data);
        })
        .catch((err) => {});
    }
    if (addBillingModelVisibility === false) {
      api
        .get(`/api/billingModel/all?serviceProvider=${parseLoginRes?.company}`)
        .then((res) => {
          setBillingModelList(res?.data?.data);
        })
        .catch((err) => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);
  const [billingModelList, setBillingModelList] = useState([]);
  const [rowData, setRowData] = useState(null);
  const [addBillingModelVisibility, setAddBillingModelVisibility] =
    useState(false);
  return (
    <div className="overflow-hidden">
      <ToastContainer />
      <Button
        onClick={() => {
          setAddBillingModelVisibility(true);
        }}
        className="text-center mr-0"
        style={{
          marginTop: "0rem",
          textAlign: "center",
          marginLeft: "90%",
          transform: "translate(-70%)",
          width: "25rem",
        }}
        label="Add Billing Model"
      />

      <Dialog
        header="Add Billing Model"
        visible={addBillingModelVisibility}
        style={{ width: "80vw" }}
        onHide={() => {
          setAddBillingModelVisibility(false);
        }}
      >
        <AddBillingModel
          setRefresh={setRefresh}
          setAddBillingModelVisibility={setAddBillingModelVisibility}
        />
      </Dialog>
      <Dialog
        header="Update Billing Model"
        visible={editBillingModelVisibility}
        className="pt-0"
        style={{ width: "80vw" }}
        onHide={() => {
          setEditBillingModelVisibility(false);
        }}
      >
        <UpdateBillingModel
          data={rowData}
          setRefresh={setRefresh}
          setEditBillingModelVisibility={setEditBillingModelVisibility}
        />
      </Dialog>
      <DataTable
        value={billingModelList}
        size="small"
        stripedRows
        emptyMessage="Billing Models Not Found"
        style={{ marginTop: "1rem" }}
      >
        <Column header="ID" field="_id" />
        <Column header="Billing Model" field="billingModel" />

        <Column
          header="Actions"
          body={(rowData) => {
            return (
              <>
                <Button
                  label="Update"
                  onClick={() => {
                    setRowData(rowData);
                    setEditBillingModelVisibility(true);
                  }}
                  className=" p-button-primary mr-2 ml-2 pt-1 pb-1"
                  text
                  raised
                />
                <Button
                  label="Delete"
                  onClick={() => {
                    api
                      .put(`/api/billingModel/delete?id=${rowData._id}`)
                      .then((res) => {
                        toast.success("Billing Model Removed Successfully");

                        setRefresh((prev) => !prev);
                      })
                      .catch((err) => {
                        toast.error("Billing Model Removal Failed");
                      });
                  }}
                  className=" p-button-primary mr-2 ml-2 pt-1 pb-1"
                  text
                  raised
                />
              </>
            );
          }}
          field="Edit"
        />
      </DataTable>
    </div>
  );
}
